module.exports = __webpack_public_path__ + "static/media/NoirPro-Medium.04b5d842.woff";